// Constants for the maintenance reducer and actions.
// @flow

export const ACTIONS = {
    ENABLE_MAINTENANCE: 'enable-maintenance-mode',
    DISABLE_MAINTENANCE: 'disable-maintenance-mode'
};



// WEBPACK FOOTER //
// ./src/state/reducer/maintenance/constants.js